<template>
  <div id="page-container">
    <qb-nav />
    <router-view class="page-container-content"></router-view>
    <qb-footer />
  </div>
</template>

<script>
import { langs } from '@/plugins/translates'
import QbNav from '@/components/layout/QbNav.vue'
import QbFooter from '@/components/layout/QbFooter.vue'

export default {
  components: {
    QbNav,
    QbFooter
  },
  data () {
    return {
      langs: langs
    }
  },
  computed: {
  },
  methods: {
    updateLang (lang) {
      if (this.langs.indexOf(lang) !== -1) {
        this.$i18n.locale = lang
        this.$vuetify.lang.current = lang
        document.getElementsByTagName('html')[0].setAttribute('lang', lang)
        document.getElementsByTagName('html')[0].setAttribute('xml:lang', lang)
        this.$root.$emit('changeed-lang', lang)
      } else {
        this.changeLang(langs[0])
      }
    },
    changeLang (lang) {
      if (this.$i18n.locale === lang) { return }
      if (this.langs.indexOf(lang) !== -1) {
        const newRoute = {
          name: this.$route.name || 'dashboard',
          params: this.$route.params || {},
          query: this.$route.query || {}
        }
        newRoute.params.lang = lang
        this.$router.replace(newRoute)
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (newRoute) {
        this.updateLang(newRoute.params.lang)
      }
    }
  },
  mounted () {
    this.$root.$on('change-lang', this.changeLang)
  },
  destroyed () {
    this.$root.$off('change-lang')
  }
}
</script>

<style lang="scss">
  @import '@/styles/main.scss';

  #page-container {
    overflow: hidden;
    min-width: 300px;
    width: 80%;
    max-width: 1080px;
    margin: 0 auto;
    height: 100%;
    // border-left: grey 1px dotted;
    // border-right: grey 1px dotted;
    .page-container-content {
      padding: 0 0 160px!important;
      @include sm { padding: 0 0 100px!important; }
      @include mdAndUp { padding: 0 0 72px!important; }
    }
  }
</style>
